import { API_HOST, PubSubType } from "@/const";
import { Payload, RootState } from "@/types/type";
import { eventSource } from "@/utils/eventSource";
import { EffectsCommandMap, getDvaApp, useNavigate } from "@umijs/max";
import { getLoginToken } from "./userInfo";
import { ChatParameter } from "./chatParameter";
import {
  convertThinkTags,
  getChatTextLengthTip,
  getRouterParams,
} from "@/utils/utils";
import { conversationSessionId, getChatMessageFinalTime } from "@/server/lb-chat";
import { getDav } from "@/utils";
import { message } from "antd";
import { userFreeTimes } from "@/server/lb-login-auth";
import { IChatOptimizeQuestionStore } from "./chatOptimizeQuestion";
import PubSub from "pubsub-js";
import {
  AGENT_STREAM_VERSION,
  AgentCapabilitiesResponse,
  AgentArtifactFormat,
  AgentArtifactIntent,
  AgentMessageState,
} from "@/types/agent";
import {
  createAgentMessageState,
  getAgentEventId,
  isAgentEvent,
  reduceAgentEvent,
} from "@/utils/agentEvent";
import {
  createChatRequestId,
  flushChatAbnormalReports,
  reportChatAbnormal,
  notifyChatRequestCancelled,
} from "@/utils/chatAbnormalReporter";
import { getAgentCapabilities } from "@/server/chat-agent";
import { classifyChatStreamFailure, isChatTransportFailure } from "@/utils/chatStreamFailure";
import { getChatErrorDisplayMessage, escapeChatErrorText } from "@/utils/chatErrorDisplay";
import { applyChatEntryFailure, ChatEntryFailureData } from "@/utils/chatEntryFailure";
import { shouldRefreshChatHistory } from "./chat-history-refresh";
import { ChatRequestRuntime, findChatRuntime, detachChatRequest } from "@/utils/chatRequestRuntime";

interface ChatGptConfig {
  frequency_penalty: number;
  max_tokens: number;
  model: string;
  presence_penalty: number;
  temperature: number;
  top_p: number;
  fileDataId?: string;
  // 多文件对话
  gptFileIds?: string[];
  gptMultipleFilesChat?: boolean;
  fileMarkType?: string;
  sceneInfo: string;
  useInternet: 0 | 1;
  messages: Array<any>;
  beforeProblemId?: string;
  isContinue?: boolean;
  pluginType?: string[];
  sessionId?: string;
  rolePlayId?: string;
  promptId?: string | number;
  imageRecognitionId?: string;
  operationType?: string;
  editChatMessage?: boolean;
  editMessageId?: string;
  regenerateAnswerId?: string;
  requestId?: string;
  retryOfRequestId?: string;
  streamVersion?: typeof AGENT_STREAM_VERSION;
  lastSequence?: number;
  webSearchMode?: "disabled" | "auto" | "required";
  artifactIntent?: AgentArtifactIntent;
  artifactFormat?: AgentArtifactFormat;
  fileContextMode?: "none" | "session";
}
export interface ChatMessage {
  chatRequestPreparing?: boolean;
  chatPending: boolean;
  chatMessageList: NConversation.ChatMessageListItem[];
  historyLoading: boolean;
  chatGptConfig: ChatGptConfig;
  cancelToken: AbortController;
  errorCode: Array<number | string>;
  userFreeTimesCount: NConversation.userFreeTimesCountTs;
  isErrorReload?: boolean;
}

// 调试代码
setTimeout(() => {
  window.xx = getDvaApp;
}, 2000);

const getDvaStore = () => {
  return getDvaApp()._store;
};

const updataLeftSideHistory = (rootState = getDvaStore().getState() as RootState) => {
  const chatMessageList = rootState.chatMessage.chatMessageList;
  type ChatHistoryMessage = NConversation.ChatMessageListItem & {
    gptFiles?: boolean;
    gptFileIds?: string[];
  };
  const newLastItem = chatMessageList.at(-1) as ChatHistoryMessage | undefined;
  const oldLastItem = chatMessageList.at(-3) as ChatHistoryMessage | undefined;
  console.log(newLastItem, oldLastItem, "newLastItem, oldLastItem");

  const hasNewFileConversation =
    newLastItem?.fileDataId &&
    newLastItem.fileDataId !== oldLastItem?.fileDataId;
  const hasNewMultiFileConversation =
    newLastItem?.gptFiles !== oldLastItem?.gptFiles &&
    Boolean(newLastItem?.gptFileIds?.length);

  // 新会话与新增文件会话都只发布一次，避免并发重复刷新。
  if (
    shouldRefreshChatHistory(chatMessageList.length) ||
    hasNewFileConversation ||
    hasNewMultiFileConversation
  ) {
    PubSub.publish(PubSubType.RESET_LEFT_HISTORY, true);
  }
  // 更新左侧历史记录，防止响应慢时，左侧历史记录不更新，只有新对话才调用  END
};

export const getDefaultChatGptConfig = () => {
  return {
    // gpt相关配置信息
    frequency_penalty: 0.0,
    max_tokens: 512,
    model: window.defaultModel.model,
    presence_penalty: 0.0,
    temperature: 0.73,
    top_p: 1.0,
    sceneInfo: "lb-chat-ui",
    sessionId: "",
    messages: [],
    useInternet: 0,
    regenerateAnswerId: "",
  };
};

export default {
  state: {
    chatRequestPreparing: false,
    chatPending: false, // ai回答sse请求loading
    chatMessageList: [], // 对话列表
    historyLoading: false, // 历史数据加载loading
    chatGptConfig: getDefaultChatGptConfig(),
    cancelToken: new AbortController(), // 取消请求
    isErrorReload: false, // 是否是错误重载
    errorCode: [
      "-20010",
      "-2002",
      "-2004",
      "-2006",
      "-2007",
      "-2019",
      "-2039",
      "-2021",
      "-2022",
      "-20004",
      "-2040",
      "-2041",
      "-2042",
      "-2043",
      "401",
      "-401",
      "-1",
    ], //错误状态码
    userFreeTimesCount: {} as NConversation.userFreeTimesCountTs, //用户免费次数
  } as ChatMessage,
  reducers: {
    setData: (state: ChatMessage, { payload }: Payload) => {
      return {
        ...state,
        ...payload,
      };
    },

    setUserFreeTimesCount: (state: ChatMessage, { payload }: Payload) => {
      return {
        ...state,
        userFreeTimesCount: payload,
      };
    },
  },
  effects: {
    *syncFinalMessageTime(
      { payload }: Payload,
      { call, put, select }: EffectsCommandMap,
    ): Generator {
      const requestId = payload?.requestId;
      const sessionId = payload?.sessionId;
      if (!requestId || !sessionId) return;

      // 流关闭与 Mongo 最终消息落库之间可能存在很短的竞态，有限重试后静默退出；
      // 历史记录刷新时仍会使用服务端 createTime。
      for (let attempt = 0; attempt < 4; attempt += 1) {
        try {
          const response: any = yield call(getChatMessageFinalTime, {
            requestId,
            sessionId,
          });
          const persistedMessage = response?.data;
          if (persistedMessage?.createTime) {
            const current = (yield select(
              (state: RootState) => state.chatMessage,
            )) as ChatMessage;
            const liveMessage = current.chatMessageList.find(
              (item) => item.requestId === requestId,
            ) || findChatRuntime(sessionId)?.state.chatMessageList.find(
              (item: any) => item.requestId === requestId,
            );
            if (liveMessage) {
              liveMessage.createTime = persistedMessage.createTime;
              liveMessage.time = persistedMessage.createTime;
              if (persistedMessage.id) liveMessage.id = persistedMessage.id;
              if (persistedMessage.messageId !== undefined) {
                liveMessage.messageId = persistedMessage.messageId;
              }
              yield put({ type: "setData", payload: {} });
            }
            return;
          }
        } catch (_error) {
          // 时间同步失败不能影响已经生成完成的正文展示。
        }
        if (attempt < 3) {
          yield call(
            () => new Promise((resolve) => window.setTimeout(resolve, 250 * (attempt + 1))),
          );
        }
      }
    },
    // 获取用户免费次数
    *getUserFreeTimes(
      { payload }: Payload,
      { call, put, select }: EffectsCommandMap,
    ): Generator {
      try {
        const { lbChatUserInfo } = (yield select(
          (state: RootState) => state.userInfo,
        )) as NUser.IUserInfoState;

        if (lbChatUserInfo?.loginToken && !lbChatUserInfo?.isVip) {
          const res: any = yield call(userFreeTimes, payload);
          if (res?.code == 0) {
            yield put({
              type: "setUserFreeTimesCount",
              payload: res.data,
            });
          }
          return Promise.resolve(res);
        }
      } catch (err) {
        return Promise.reject();
      }
    },
    *stop(
      { payload }: Payload,
      { call, put, select }: EffectsCommandMap,
    ): Generator {
      const { cancelToken, chatPending, chatRequestPreparing, chatGptConfig, chatMessageList } = (yield select(
        (state: RootState) => state.chatMessage,
      )) as ChatMessage;

      // 导航只分离视图，保留本页面的后台请求；真正停止和技术故障仍走原收尾。
      if (!payload?.userRequested && !payload?.technicalFailure &&
          detachChatRequest(cancelToken)) return;

      // 只有用户点击“停止生成”才取消服务端 Agent；切页、断网和技术性中止只断本地流。
      const shouldNotifyCancellation =
        chatPending && payload?.userRequested === true;
      if (chatRequestPreparing) {
        // 能力查询期间尚未提交生成请求，不能拿上一轮 requestId 调用取消接口。
        cancelToken.abort();
        yield put({ type: "setData", payload: { chatPending: false, chatRequestPreparing: false } });
        return;
      }
      let activeRequestId = chatGptConfig.requestId;
      const activeSessionId = chatGptConfig.sessionId;
      if (shouldNotifyCancellation) {
        const stoppingMessage = chatMessageList.find((item) => item.requestId === activeRequestId);
        if (stoppingMessage?.stopPending) return;
        const stopAttempt = {};
        if (stoppingMessage) {
          stoppingMessage.stopPending = true;
          stoppingMessage.stopAttempt = stopAttempt;
        }
        yield put({ type: "setData", payload: {} });
        // 先让服务端确认取消，再断开 SSE；反过来会使普通流提前按完成收尾。
        let result: any;
        const ownsAttempt = () => Boolean(stoppingMessage && stoppingMessage.stopAttempt === stopAttempt);
        try {
          // onopen 可将客户端 ID 替换为服务端 ID；最多追随一次，不能取消下一轮生成。
          for (let attempt = 0; attempt < 2; attempt++) {
            result = yield call(
              notifyChatRequestCancelled,
              activeRequestId,
              activeSessionId,
              "USER_REQUESTED",
              () => {
                const current = getDvaStore().getState().chatMessage;
                return ownsAttempt() && current.cancelToken === cancelToken
                  && current.chatGptConfig.requestId === activeRequestId
                  && stoppingMessage?.requestId === activeRequestId;
              },
            );
            if (!ownsAttempt() || stoppingMessage?.requestId === activeRequestId) break;
            result = null;
            const current = getDvaStore().getState().chatMessage;
            if (current.cancelToken !== cancelToken ||
                current.chatGptConfig.requestId !== stoppingMessage?.requestId) break;
            activeRequestId = stoppingMessage?.requestId;
          }
        } catch (_error) {
          // 取消接口异常不能让当前页永远停留在“正在停止生成”。
          result = null;
        } finally {
          if (ownsAttempt()) stoppingMessage!.stopPending = false;
          yield put({ type: "setData", payload: {} });
        }
        const stillOriginalRequest = ownsAttempt() && stoppingMessage?.requestId === activeRequestId;
        const deferredFailure = stillOriginalRequest ? stoppingMessage?.deferredStopFailure : undefined;
        if (stoppingMessage && ownsAttempt()) {
          if (!stillOriginalRequest) result = null;
          if (result?.accepted) stoppingMessage.cancelConfirmed = true;
          if (result?.accepted && !stoppingMessage.agentState) stoppingMessage.generationStatus = "CANCELLED";
          stoppingMessage.stopRecoveryPending = Boolean(stoppingMessage.agentState && !stoppingMessage.agentState.terminal);
          delete stoppingMessage.stopAttempt;
          delete stoppingMessage.deferredStopFailure;
        }
        yield put({ type: "setData", payload: {} });
        if (!stillOriginalRequest) return;
        if (!result?.accepted) {
          deferredFailure?.();
          const current = (yield select((state: RootState) => state.chatMessage)) as ChatMessage;
          if (!result?.status && !stoppingMessage?.agentState?.terminal
              && !stoppingMessage?.cancelConfirmed && current.cancelToken === cancelToken
              && current.chatGptConfig?.requestId === activeRequestId) {
            message.warning("暂未确认停止，请稍后重试");
          }
          return;
        }
        if (!stoppingMessage?.agentState) {
          yield put({
            type: "syncFinalMessageTime",
            payload: {
              requestId: activeRequestId,
              sessionId: activeSessionId,
            },
          });
        }
        const current = (yield select((state: RootState) => state.chatMessage)) as ChatMessage;
        const target = current.chatMessageList.find((item: any) => item.requestId === activeRequestId);
        if (target && !target.agentState) {
          (target as any).generationStatus = "CANCELLED";
          yield put({ type: "setData", payload: {} });
        }
      }
      // 使用点击时捕获的 controller，不能中止等待取消结果期间新发起的请求。
      cancelToken.abort();
      // 文件流可能先进入错误终态，随后 abort 不会再触发 onclose。
      // 无论回调是否执行，都要收尾当前本地请求；旧请求不得解锁新请求的输入框。
      const current = (yield select((state: RootState) => state.chatMessage)) as ChatMessage;
      if (current.cancelToken === cancelToken) {
        const target = current.chatMessageList.find((item) => item.requestId === activeRequestId);
        if (target) target.isDone = true;
        yield put({
          type: "setData",
          payload: { chatPending: false, chatRequestPreparing: false },
        });
      }
    },
    // 对话列表会话
    *chat(
      { payload }: Payload,
      { call, put: livePut, select: liveSelect }: EffectsCommandMap,
    ): Generator {
      let runtime: ChatRequestRuntime | undefined;
      const liveStore = getDvaApp()._store;
      const getDvaStore = () => runtime || liveStore;
      const select = (selector: (state: any) => any) =>
        liveSelect((state: any) => selector(runtime ? runtime.getState() : state));
      const put = (action: any) => runtime
        ? call(() => runtime!.dispatch(action)) : livePut(action);
      const {
        conversationItem,
        chatTextarea,
        enablePlugins,
        gptMode,
        chatInputImage,
        messagePolledData,
        currentImageId,
      } = (yield select(
        (state: RootState) => state.chatParameter,
      )) as ChatParameter;

      const { siteConfig } = (yield select(
        (state: RootState) => state.site,
      )) as NSite.IModelState;

      let inputVal = chatTextarea;

      const { selectedChatRules, allChatRuleItems } = (yield select(
        (state: RootState) => {
          return state.chatOptimizeQuestion;
        },
      )) as IChatOptimizeQuestionStore;

      if (selectedChatRules.length && allChatRuleItems.length) {
        const optimizeText = allChatRuleItems
          .filter((n) => selectedChatRules.includes(n.id))
          .map((n) => n.content)
          .join(" ");
        inputVal = `${inputVal?.trim()} ${optimizeText}`;
      }

      // 判空是否未输入
      if (!payload && !chatTextarea) {
        message.destroy();
        message.warning("请输入要提问的内容~");
        return;
      }
      let limitNum = siteConfig.ai_chat_input_length;
      if (gptMode.model === "gpt-5" && siteConfig.gpt_plus_enable === "true") {
        limitNum = siteConfig.gpt4_token_length_limit;
      } else if (gptMode.model === "claude") {
        limitNum = siteConfig.claude_ai_chat_input_length;
      } else if (gptMode.model === "o1-mini") {
        limitNum = siteConfig.ai_chat_o1_input_length;
      } else if (gptMode.model === "o1-preview") {
        limitNum = siteConfig.ai_chat_o1_pre_input_length;
      } else if (gptMode.model === "deepseek-ai/DeepSeek-R1") {
        limitNum = siteConfig.deepseek_reasoner_ai_chat_input_length;
      }

      console.log(limitNum, "limitNum");

      if (
        yield getChatTextLengthTip(chatTextarea || payload.content || "", limitNum)
      ) {
        return;
      }

      // if (getChatTextLengthTip(chatTextarea || payload.content || "",
      // gptMode.model === "gpt-4" && siteConfig.gpt_plus_enable === "true" ? siteConfig.gpt4_token_length_limit : siteConfig.ai_chat_input_length)) {
      //   return;
      // }

      yield put({
        type: "chatParameter/setHasChatStream",
        payload: false,
      });

      // 获取用户信息
      const { lbChatUserInfo } = (yield select(
        (state: RootState) => state.userInfo,
      )) as NUser.IUserInfoState;

      if (!lbChatUserInfo?.loginToken) {
        yield put({
          type: "userParameter/setHasResetPassword",
          payload: false,
        });
        yield put({ type: "userParameter/setHasLoginPop", payload: true });
        // 未登录情况下发送的消息问题
        localStorage.setItem("lb-chat-noLogin-text", payload || chatTextarea);
        return false;
      }

      let { chatMessageList } = (yield select(
        (state: RootState) => state.chatMessage,
      )) as ChatMessage;

      const oldSessionId = getRouterParams().sessionid;

      const sessionId = conversationItem?.id || oldSessionId;

      const existing = findChatRuntime(sessionId);
      if (existing?.state.chatPending || existing?.state.chatRequestPreparing) return false;
      const cancelToken = new AbortController();
      runtime = new ChatRequestRuntime(String(sessionId), liveStore, cancelToken);
      yield put({
        type: "setData",
        payload: { chatPending: true, chatRequestPreparing: true, cancelToken },
      });

      // // 新会话
      const { chatGptConfig, errorCode } = (yield select(
        (state: RootState) => state.chatMessage,
      )) as ChatMessage;

      const notBindFileCode = errorCode.filter(
        (n) => !["-20004", "-20010"].includes(n as string),
      );

      // 开始流式传输前 解析请求信息
      let requestConfig: ChatGptConfig = {
        ...chatGptConfig,
        fileDataId: chatGptConfig.fileDataId || messagePolledData.fileDataId,
        model: gptMode.model,
        messages: chatMessageList,
        pluginType: conversationItem?.pluginType,
        rolePlayId: conversationItem?.rolePlayId,
        // Chat6-Sol 由当前消息的 Agent 自动决策；其他模型保留既有手动联网逻辑。
        useInternet:
          gptMode.model === "gpt-5" ? 0 : conversationItem?.useInternet || 0,
        imageRecognitionId: currentImageId || chatGptConfig.imageRecognitionId,
      };
      const regenerateTarget = chatGptConfig.regenerateAnswerId
        ? chatMessageList.find(
            (item) => item.id === chatGptConfig.regenerateAnswerId,
          )
        : undefined;
      const previousAgentRequestId =
        regenerateTarget?.agentRequestId ||
        (regenerateTarget?.agentProtocolVersion === AGENT_STREAM_VERSION
          ? regenerateTarget?.requestId
          : undefined);
      const isAgentRegeneration = Boolean(
        chatGptConfig.regenerateAnswerId && previousAgentRequestId,
      );
      const previousRequestId =
        previousAgentRequestId || regenerateTarget?.requestId;
      const requestId = createChatRequestId();
      requestConfig.requestId = requestId;
      requestConfig.retryOfRequestId = previousRequestId;
      requestConfig.sessionId = String(sessionId);

      // 文件上传参数解析

      if (payload?.type === "file" || payload?.type === "fileList") {
        payload.fileMarkType = "start";

        if (payload?.type === "fileList") {
          requestConfig.gptFileIds = payload.gptFileIds;
        } else {
          requestConfig.fileDataId = payload.id;
        }

        requestConfig.fileMarkType = "start";
      } else {
        requestConfig.fileMarkType = "";
      }

      if (requestConfig.fileDataId) {
        requestConfig.useInternet = 0;
      }

      const beParaphrasing =
        chatMessageList.at(-1)?.operationType === "pre_paraphrasing";
      if (beParaphrasing) {
        requestConfig.operationType = "paraphrasing";
      } else {
        requestConfig.operationType = "question";
      }

      // 预设问题
      if (payload?.operationType) {
        requestConfig.operationType = payload.operationType;
        requestConfig.fileDataId = messagePolledData.fileDataId;
      }
      const hasAttachedHistory = chatMessageList.some((item: any) =>
        item.fileDataId || item.fileDataIds?.length || item.gptFiles);
      const hasStoredFileContext = Boolean(
        requestConfig.fileDataId || requestConfig.gptFileIds?.length ||
        requestConfig.gptMultipleFilesChat || messagePolledData.gptFiles ||
        messagePolledData.fileDataId || hasAttachedHistory,
      );
      requestConfig.fileContextMode = payload?.fileContextMode ||
        (hasStoredFileContext ? "session" : "none");
      if (requestConfig.fileContextMode === "none") {
        delete requestConfig.fileDataId;
        delete requestConfig.gptFileIds;
        requestConfig.gptMultipleFilesChat = false;
      }
      console.log("requestConfig", requestConfig);

      // 图片解读
      if (gptMode.model === "gpt-5") {
        if (chatInputImage) {
          requestConfig.imageRecognitionId = chatInputImage.imageRecognitionId;
          getDvaStore().dispatch({
            type: "chatParameter/setCurrentImageId",
            payload: chatInputImage.imageRecognitionId,
          });
          requestConfig.useInternet = 0;
        }
      } else {
        requestConfig.imageRecognitionId = "";
      }

      const isAgentReplayRequest = Boolean(
        payload?.type === "continue" ||
          payload?.editMessageId ||
          (chatGptConfig.regenerateAnswerId && !isAgentRegeneration),
      );
      const hasUnsupportedAgentContext = Boolean(
        isAgentReplayRequest ||
          requestConfig.imageRecognitionId ||
          requestConfig.rolePlayId ||
          requestConfig.pluginType?.length ||
          (requestConfig.promptId && Number(requestConfig.promptId) !== 0) ||
          requestConfig.operationType !== "question" ||
          enablePlugins?.length,
      );
      const agentCandidate = Boolean(
        (requestConfig.model === "gpt-5" ||
          requestConfig.model === "gpt-4o-mini") &&
          !hasUnsupportedAgentContext,
      );
      let agentCapabilities: AgentCapabilitiesResponse | null = null;
      try {
        if (agentCandidate) agentCapabilities = (yield call(getAgentCapabilities)) as AgentCapabilitiesResponse;
      } catch (error) {
        yield put({ type: "setData", payload: { chatPending: false, chatRequestPreparing: false } });
        if (liveStore.getState().chatMessage.cancelToken === cancelToken) {
          message.error("模型能力查询失败，请稍后重试");
        }
        return false;
      }
      if (cancelToken.signal.aborted) return false;
      const supportsAgentV1 = Boolean(
        agentCapabilities?.enabled === true &&
          agentCapabilities.streamVersion === AGENT_STREAM_VERSION &&
          (agentCapabilities.businessModels?.includes(requestConfig.model) === true ||
            (requestConfig.model === "gpt-5" &&
              !agentCapabilities.businessModels?.length)),
      );
      if (hasStoredFileContext && requestConfig.fileContextMode === "none" &&
          agentCandidate && !supportsAgentV1) {
        message.error("本轮不引用附件需要 Agent 能力，请稍后重试");
        yield put({ type: "setData", payload: { chatPending: false, chatRequestPreparing: false } });
        return false;
      }
      const regenerationNeedsArtifact = Boolean(
        regenerateTarget?.artifacts?.length ||
          regenerateTarget?.artifactIds?.length,
      );

      // 已经由 Agent 生成的回答必须继续走 Agent。能力接口异常或文件能力关闭时
      // 直接拒绝本次重试，避免静默退回旧对话链路后生成不可下载的“文本链接”。
      if (
        isAgentRegeneration &&
        (!supportsAgentV1 ||
          (regenerationNeedsArtifact && agentCapabilities?.artifactEnabled !== true))
      ) {
        message.error(
          regenerationNeedsArtifact
            ? "结果文件重新生成暂不可用，请稍后重试"
            : "Agent 重新生成暂不可用，请稍后重试",
        );
        yield put({
          type: "setData",
          payload: { chatPending: false, chatRequestPreparing: false },
        });
        return false;
      }

      delete requestConfig.streamVersion;
      delete requestConfig.lastSequence;
      delete requestConfig.webSearchMode;
      delete requestConfig.artifactIntent;
      delete requestConfig.artifactFormat;

      if (supportsAgentV1) {
        // Old conversations may still store useInternet=1; Agent decides per message.
        requestConfig.useInternet = 0;
        if (!requestConfig.imageRecognitionId) delete requestConfig.imageRecognitionId;
        if (!requestConfig.fileDataId) delete requestConfig.fileDataId;
        if (!requestConfig.rolePlayId) delete requestConfig.rolePlayId;
        requestConfig.streamVersion = AGENT_STREAM_VERSION;
        requestConfig.webSearchMode = "auto";
        requestConfig.artifactIntent = agentCapabilities?.artifactEnabled
          ? "auto"
          : "none";
        requestConfig.artifactFormat = agentCapabilities?.artifactEnabled
          ? "auto"
          : undefined;
      }

      // 问题编辑参数
      if (payload?.editMessageId) {
        const preUserConvaersation = chatMessageList.find((n, index) => {
          return chatMessageList[index + 2]?.id === payload?.editMessageId;
        });

        const switchIndex = chatMessageList.findIndex((n, index) => {
          return n.id === payload?.editId;
        });

        if (switchIndex !== -1) {
          chatMessageList = chatMessageList.slice(0, switchIndex);
          yield put({ type: "setData", payload: { chatMessageList } });

          requestConfig.editChatMessage = true;
          requestConfig.beforeProblemId = preUserConvaersation?.id;
          requestConfig.editMessageId =
            payload.childMessages?.[0]?.id ?? payload.id;
        }
      } else {
        requestConfig.editChatMessage = undefined;
        if (chatMessageList.at(-2)?.messageId !== undefined) {
          requestConfig.beforeProblemId = chatMessageList.at(-2)?.id;
        } else {
          const promptMsgIndex = chatMessageList.findLastIndex(
            (item) => item.messageId !== undefined,
          );
          if (promptMsgIndex !== -1) {
            requestConfig.beforeProblemId =
              chatMessageList[promptMsgIndex - 1]?.id;
          }
        }
      }

      yield put({
        type: "setData",
        payload: { chatGptConfig: requestConfig },
      });

      const newMessages: NConversation.ChatMessageListItem[] = [
        {
          content: payload?.fileName || (inputVal as string),
          isDone: true,
          tempId: Date.now().toString() + "1",
          isError: false,
          id: chatGptConfig.regenerateAnswerId
            ? chatGptConfig.regenerateAnswerId
            : "",
          messageType: 1,
          ...(payload ? payload : {}),
          role: "user",
        },
        {
          isDone: false,
          tempId: Date.now().toString() + "2",
          isError: false,
          id: chatGptConfig.regenerateAnswerId
            ? chatGptConfig.regenerateAnswerId
            : "",
          messageType: 2,
          ...(payload ? payload : {}),
          content: "",
          paintingGuide: false,
          role: "assistant",
          requestId,
          gptModel: requestConfig.model,
          sessionId: requestConfig.sessionId,
          ...(supportsAgentV1
            ? {
                agentRequestId: requestId,
                agentProtocolVersion: AGENT_STREAM_VERSION,
                agentStatus: "STARTING",
              }
            : {}),
        },
      ];
      let chatMessage = newMessages[1];
      let messageList: any = [];
      let reloadMessageList: any = [];
      if (chatGptConfig && chatGptConfig.regenerateAnswerId) {
        const regenerateIndex = chatMessageList.findIndex(
          (item) => item.id === chatGptConfig.regenerateAnswerId,
        );
        if (regenerateIndex !== -1) {
          chatMessageList[regenerateIndex] = chatMessage;
          reloadMessageList = chatMessageList.slice(0, regenerateIndex);
        }
        messageList = [...chatMessageList];
      } else {
        messageList = [...chatMessageList, ...newMessages];
      }

      // 继续会话
      if (payload?.type === "continue" && chatMessageList.length) {
        chatMessage = chatMessageList.at(
          -1,
        ) as NConversation.ChatMessageListItem;
        messageList = [...chatMessageList];
        requestConfig.isContinue = true;
        chatMessage.isDone = false;
        delete chatMessage.generationStatus;
        delete chatMessage.paintingGuide;
        delete chatMessage.entryFailure;
        delete chatMessage.skipMessageIdLookup;
        delete chatMessage.stopPending;
        delete chatMessage.stopAttempt;
        delete chatMessage.stopRecoveryPending;
        delete chatMessage.cancelConfirmed;
        delete chatMessage.deferredStopFailure;
        chatMessage.requestId = requestId;
        chatMessage.gptModel = requestConfig.model;
        chatMessage.sessionId = requestConfig.sessionId;
      }

      yield put({
        type: "setData",
        payload: {
          chatMessageList: messageList,
        },
      });

      yield put({ type: "chatParameter/setChatTextarea", payload: "" });

      const serviceUrl = lbChatUserInfo?.loginToken
        ? process.env.Chat_Service_Url
        : process.env.Chat_No_Service_Url;
      const httpUrl = `${API_HOST}${serviceUrl}`;

      let links: string[],
        superAdditionList: Record<string, any>,
        useInternet: number;
      let isInThinking = false;
      let receivedStreamData = false;
      let effectiveRequestId = requestId;
      let strictCompletionRequired = false;
      let agentProtocolConfirmed = false;
      let agentState: AgentMessageState | undefined = supportsAgentV1
        ? chatMessage.agentState || createAgentMessageState(requestId)
        : undefined;
      const isFileChatRequest = !supportsAgentV1 && Boolean(
          requestConfig.gptMultipleFilesChat ||
          requestConfig.gptFileIds?.length ||
          requestConfig.fileDataId,
      );
      const streamHeaders: Record<string, string> = {
        token: getLoginToken(),
        "Content-Type": "application/json",
        accept: "text/event-stream",
      };
      if (supportsAgentV1) {
        streamHeaders["X-Chat-Stream-Version"] = AGENT_STREAM_VERSION;
        streamHeaders["X-Chat-Request-Id"] = requestId;
      }

      const syncAgentMessage = (next: AgentMessageState) => {
        agentState = next;
        chatMessage.agentState = next;
        chatMessage.agentRequestId = next.requestId;
        chatMessage.agentProtocolVersion = AGENT_STREAM_VERSION;
        chatMessage.agentStatus = next.status;
        chatMessage.useInternet = requestConfig.useInternet;
        chatMessage.content = next.textSnapshot;
        chatMessage.citations = next.citations;
        chatMessage.searchSources = next.sources;
        chatMessage.artifacts = next.artifacts;
        chatMessage.artifactIds = next.artifacts.map(
          (artifact) => artifact.artifactId,
        );
        if (next.terminal) {
          chatMessage.stopPending = false;
          chatMessage.stopRecoveryPending = false;
          if (next.status === "CANCELLED") chatMessage.cancelConfirmed = true;
          delete chatMessage.deferredStopFailure;
        }
        if (next.terminal && next.updatedAt) {
          chatMessage.createTime = next.updatedAt;
          chatMessage.time = next.updatedAt;
        }
        getDvaStore().dispatch({ type: "chatMessage/setData", payload: {} });
      };

      if (cancelToken.signal.aborted) return false;
      getDvaStore().dispatch({ type: "chatMessage/setData", payload: { chatRequestPreparing: false } });
      eventSource(httpUrl, {
        method: "post",
        body: JSON.stringify({
          ...requestConfig,
          sessionId,
          messages:
            payload?.type === "continue"
              ? messageList
              : chatGptConfig.regenerateAnswerId
              ? reloadMessageList
              : messageList.slice(0, -1),
        }),
        headers: streamHeaders,
        async onopen(response) {
          agentProtocolConfirmed =
            response.headers.get("X-Chat-Stream-Version") ===
            AGENT_STREAM_VERSION;
          // SEARCH may legitimately route to the existing SkyAI stream during
          // gray rollout. Remove the provisional Agent projection as soon as the
          // server declines agent-v1, otherwise history recovery would poll a
          // requestId that was never claimed by the Agent service.
          if (supportsAgentV1 && !agentProtocolConfirmed) {
            agentState = undefined;
            delete chatMessage.agentState;
            delete chatMessage.agentRequestId;
            delete chatMessage.agentProtocolVersion;
            delete chatMessage.agentStatus;
            delete chatMessage.citations;
            delete chatMessage.searchSources;
            delete chatMessage.artifacts;
            delete chatMessage.artifactIds;
          }
          strictCompletionRequired =
            response.headers.get("X-Chat-Strict-Stream-Completion") === "true";
          const serverRequestId = response.headers.get("X-Chat-Request-Id");
          if (serverRequestId && /^[A-Za-z0-9_-]{16,64}$/.test(serverRequestId)) {
            effectiveRequestId = serverRequestId;
            requestConfig.requestId = serverRequestId;
            chatMessage.requestId = serverRequestId;
            if (
              supportsAgentV1 &&
              agentProtocolConfirmed &&
              serverRequestId !== agentState?.requestId
            ) {
              agentState = createAgentMessageState(serverRequestId);
              streamHeaders["X-Chat-Request-Id"] = serverRequestId;
            }
            const currentConfig = getDvaStore().getState().chatMessage.chatGptConfig;
            getDvaStore().dispatch({
              type: "chatMessage/setData",
              payload: {
                chatGptConfig: {
                  ...currentConfig,
                  requestId: serverRequestId,
                  sessionId: String(sessionId),
                },
              },
            });
          }
          // A request is recoverable only after the server has explicitly
          // accepted agent-v1. Keeping the locally generated requestId solely in
          // memory prevents pre-stream business rejections from being polled as
          // if a durable Agent request existed.
          if (supportsAgentV1 && agentProtocolConfirmed && agentState) {
            syncAgentMessage(agentState);
          }
          if (!response.ok) {
            const errorBody = await response
              .clone()
              .json()
              .catch(() => null);
            const error = new Error(`HTTP ${response.status}`) as Error & {
              status?: number;
              code?: string | number;
              requestStatusPath?: string;
              savedTurn?: ChatEntryFailureData;
            };
            error.status = response.status;
            error.savedTurn = errorBody?.data;
            error.requestStatusPath =
              errorBody?.data?.requestStatusPath || errorBody?.requestStatusPath;
            error.code =
              errorBody?.data?.errorCode ||
              errorBody?.data?.code ||
              (response.status === 409 && error.requestStatusPath
                ? "AGENT_STREAM_RECOVERY_REQUIRED"
                : errorBody?.code);
            if (errorBody?.msg || errorBody?.message) {
              error.message = errorBody.msg || errorBody.message;
            }
            throw error;
          }
        },
        onmessage(e, originData) {
          // 状态查询可能比 SSE 更早得到终态，迟到的流事件不能将页面恢复成运行中。
          if (chatMessage.agentState?.terminal) return;
          if (
            supportsAgentV1 &&
            (agentProtocolConfirmed || e.event === "agent") &&
            isAgentEvent(originData)
          ) {
            receivedStreamData = true;
            agentProtocolConfirmed = true;
            const next = reduceAgentEvent(chatMessage.agentState || agentState, originData);
            syncAgentMessage(next);
            const lastEventId = getAgentEventId(next);
            if (lastEventId) streamHeaders["Last-Event-ID"] = lastEventId;
            return;
          }
          if (typeof originData?.paintingGuide === "boolean") {
            chatMessage.paintingGuide = originData.paintingGuide;
          }
          if (originData?.model === "error") {
            chatMessage.messageCategory = "error";
          }
          console.log("onmessage");
          const choices = originData?.choices;
          const hasRealContent =
            Array.isArray(choices) &&
            choices.some(
              (choice: any) =>
                choice?.delta?.content || choice?.delta?.reasoning_content,
            );
          if (hasRealContent) {
            receivedStreamData = true;
          }
          superAdditionList = originData?.superAdditionList;
          if (chatMessage.isDone) return;

          let jsonData;
          links = originData?.links;

          useInternet = originData?.useInternet;

          if (e.event == "continue") {
            // 未写完的判断
            getDvaStore().dispatch({
              type: "chatParameter/setHasChatStream",
              payload: true,
            });
          }

          try {
            jsonData = JSON.parse(e.data);
          } catch (e) {}

          if (Object.prototype.toString.call(jsonData) === "[object Object]") {
            if (jsonData.code === -2004) {
              chatMessage.messageCategory = "sensitive";
              chatMessage.sensitiveType = "input";
            }
            if (jsonData.code === -20004) {
              chatMessage.messageCategory = "sensitive";
              chatMessage.sensitiveType = "output";
            }

            if (
              notBindFileCode.includes(jsonData.code?.toString()) &&
              chatMessage.fileType
            ) {
              // 敏感词不会绑定上传文件信息 清空fileDataId
              getDvaStore().dispatch({
                type: "chatMessage/setData",
                payload: {
                  chatGptConfig: {
                    ...getDvaStore().getState().chatMessage.chatGptConfig,
                    fileDataId: "",
                  },
                },
              });
            }
            if (jsonData.code == -20010) {
              getDvaStore().dispatch({
                type: "userParameter/setSqueezeInfo",
                payload: { ...jsonData.data, show: true },
              });
              getDvaStore().dispatch({
                type: "chatParameter/setChatReadingState",
                payload: false,
              });
              return;
            }
            if (errorCode.includes(jsonData?.code?.toString?.())) {
              chatMessage.errCode = jsonData?.code?.toString?.();
              chatMessage.content = jsonData?.msg;
              // 刷新视图
              getDvaStore().dispatch({
                type: "chatMessage/setData",
                payload: {},
              });
              getDvaStore().dispatch({
                type: "chatParameter/setEditDisabled",
                payload: false,
              });
              return;
            }
          }

          // 字符串流
          let str = "";
          console.log("originData===", originData, "e.data===", e.data);
          const reasoningContent = originData?.choices?.[0]?.delta?.reasoning_content;
          const normalContent = originData?.choices?.[0]?.delta?.content;
          console.log("reasoningContent===", reasoningContent, "normalContent===", normalContent);

          if (reasoningContent) {
            if (!isInThinking) {
              str += "<think>";
              isInThinking = true;
            }
            str += reasoningContent;
          } else if (normalContent !== undefined && normalContent !== null) {
            if (isInThinking) {
              str += "</think>";
              isInThinking = false;
            }
            str += e.data;
          } else {
            str = e.data;
          }

          str = convertThinkTags(str);
          chatMessage.content += str;
          // 刷新视图
          getDvaStore().dispatch({
            type: "chatMessage/setData",
            payload: {},
          });
        },
        onclose(type?: string) {
          const current = getDvaStore().getState().chatMessage;
          if (current.cancelToken !== cancelToken) return;
          // 清空reload模式的状态判断
          getDvaStore().dispatch({
            type: "chatMessage/setData",
            payload: {
              chatGptConfig: {
                ...current.chatGptConfig,
                regenerateAnswerId: "",
              },
            },
          });
          console.log(superAdditionList, "superAdditionList");

          chatMessage.superAdditionList = superAdditionList;
          if (chatMessage.isDone) return;
          if (type !== "abort" && !receivedStreamData && chatMessage.generationStatus !== "CANCELLED") {
            const reportEmptyResponse = () => {
              reportChatAbnormal({
                requestId: effectiveRequestId,
                sessionId: String(sessionId),
                messageId: chatMessage.id ? String(chatMessage.id) : undefined,
                model: requestConfig.model,
                errorType: "EMPTY_RESPONSE",
                errorMessage: "SSE closed without a valid response",
              });
              // 没有有效正文不能只留下空白气泡；原始原因仍单独上报。
              chatMessage.isError = true;
              chatMessage.canRegenerate = true;
              chatMessage.messageCategory = "error";
              chatMessage.content = (chatMessage.content || "") + "\n\n模型未返回有效内容，请重试。";
              getDvaStore().dispatch({ type: "chatMessage/setData", payload: {} });
            };
            // 取消确认与 SSE 关闭可能乱序；拒绝取消时再报告，确认取消则丢弃此传输告警。
            if (chatMessage.stopPending) chatMessage.deferredStopFailure ||= reportEmptyResponse;
            else reportEmptyResponse();
          }
          if (!agentProtocolConfirmed) {
            chatMessage.links = links;
            chatMessage.useInternet = useInternet;
          }
          chatMessage.isDone = true;
          if (type !== "abort" && !agentProtocolConfirmed) {
            getDvaStore().dispatch({
              type: "chatMessage/syncFinalMessageTime",
              payload: {
                requestId: effectiveRequestId,
                sessionId: String(sessionId),
              },
            });
          }
          getDvaStore().dispatch({
            type: "chatMessage/setData",
            payload: { chatPending: false },
          });
          if (!agentState?.deferred || agentState.terminal) {
            getDvaStore().dispatch({
              type: "chatMessage/getUserFreeTimes",
            });
          }

          // 更新左侧历史记录，防止响应慢时，左侧历史记录不更新，只有新对话才调用
          updataLeftSideHistory(getDvaStore().getState());
          // 更新左侧历史记录，防止响应慢时，左侧历史记录不更新，只有新对话才调用  END
          getDvaStore().dispatch({
            type: "leftSideX/refreshConversationCount",
          });
          void flushChatAbnormalReports();
        },
        onerror: function handleStreamError(errMsg, errInfo, stopRejected = false) {
          if (getDvaStore().getState().chatMessage.cancelToken !== cancelToken) return;
          if (chatMessage.cancelConfirmed || chatMessage.agentState?.terminal) return;
          if (chatMessage.generationStatus === "CANCELLED") return;
          // 必须先处理主动停止，再判断技术断线恢复，否则取消在途会闪现恢复提示。
          if (chatMessage.stopPending && !stopRejected) {
            chatMessage.deferredStopFailure = () => handleStreamError(errMsg, errInfo, true);
            return;
          }
          const agentErrorCode = String(errInfo?.code || "");
          const agentHttpStatus = Number(errInfo?.status || 0);
          const entryHttpFailure = supportsAgentV1 && !agentProtocolConfirmed && agentHttpStatus >= 400;
          const savedTurn = errInfo?.savedTurn as ChatEntryFailureData | undefined;
          if (entryHttpFailure) {
            const question = messageList[messageList.indexOf(chatMessage) - 1];
            applyChatEntryFailure(savedTurn, question, chatMessage, effectiveRequestId, String(sessionId));
          }
          const recoverableAgentTransportFailure =
            supportsAgentV1 &&
            agentProtocolConfirmed &&
            agentState &&
            ([
              "AGENT_STREAM_RECOVERY_REQUIRED",
              "AGENT_STREAM_INCOMPLETE",
            ].includes(agentErrorCode) ||
              (isChatTransportFailure(errInfo) && (!agentErrorCode || agentErrorCode === "CLIENT_TIMEOUT") &&
                (!agentHttpStatus || agentHttpStatus >= 500)));
          if (
            recoverableAgentTransportFailure && agentState
          ) {
            const recoverableState: AgentMessageState = {
              ...agentState,
              deliveryMode: "BACKGROUND",
              deferred: true,
              streamRecoverable: false,
              requestStatusPath:
                errInfo?.requestStatusPath || agentState.requestStatusPath,
            };
            syncAgentMessage(recoverableState);
            chatMessage.isDone = true;
            getDvaStore().dispatch({
              type: "chatMessage/setData",
              payload: { chatPending: false },
            });
            return;
          }
          if (chatMessage.isDone && !stopRejected) return;
          const errorCode = errInfo?.code?.toString?.();
          const errorType = classifyChatStreamFailure(String(errMsg || ""), errInfo,
            receivedStreamData, typeof navigator === "undefined" || navigator.onLine);
          if (errorType && (!entryHttpFailure || savedTurn?.requestTraceAvailable === true)
              && savedTurn?.businessRejected !== true) {
            reportChatAbnormal({
              requestId: effectiveRequestId,
              sessionId: String(sessionId),
              messageId: chatMessage.id ? String(chatMessage.id) : undefined,
              model: requestConfig.model,
              errorType,
              errorCode: errorCode || errInfo?.status?.toString?.(),
              errorMessage: String(errMsg || "SSE request failed"),
            });
          }

          chatMessage.messageCategory = "error";
          console.log(errInfo, "errInfo");
          chatMessage.isDone = true;
          chatMessage.isError = true;
          chatMessage.canRegenerate = true;
          if (errInfo) {
            chatMessage.errCode = errorCode;
          }
          if (isFileChatRequest && receivedStreamData && chatMessage.content) {
            if (isInThinking) {
              chatMessage.content += "</think>";
              isInThinking = false;
            }
            chatMessage.content +=
              "\n\n<font color='red'>本次回答未完整生成，请重新生成。</font>";
          } else {
            chatMessage.content = `<font color='red'>${escapeChatErrorText(getChatErrorDisplayMessage(errMsg, errorCode || errInfo?.status))}</font>`;
          }

          // 更新左侧历史记录，防止响应慢时，左侧历史记录不更新，只有新对话才调用
          updataLeftSideHistory(getDvaStore().getState());
          // 更新左侧历史记录，防止响应慢时，左侧历史记录不更新，只有新对话才调用  END

          getDvaStore().dispatch({
            type: "chatMessage/setData",
            payload: { chatPending: false },
          });
          getDvaStore().dispatch({
            type: "chatMessage/stop",
            payload: { technicalFailure: true },
          });
          if (errInfo && !stopRejected) {
            throw Error(errInfo);
          }
        },
        tryTimes: supportsAgentV1 ? 3 : 0,
        includeErrorOrigin: true,
        timeout: () =>
          supportsAgentV1
            ? 1000 * 60 * 16
            : strictCompletionRequired
            ? 1000 * 60 * 12
            : 1000 * 60 * 3,
        requireDone: () => strictCompletionRequired,
        requireAgentTerminal: () => supportsAgentV1 && agentProtocolConfirmed,
        signal: cancelToken.signal,
      });

      //
      yield put({
        type: "setData",
        payload: {
          chatGptConfig: {
            ...requestConfig,
            isContinue: undefined,
          },
        },
      });

      // 每次会话结束清空图片信息
      yield put({
        type: "chatParameter/setChatInputImage",
        payload: undefined,
      });
      // 开始流式传输后 解析请求信息
      yield put({ type: "afterRequest", payload: payload });
    },
    // 发起新会话 重置stream参数 拉取sessionId
    *newChat(
      { payload }: Payload,
      { call, put, select }: EffectsCommandMap,
    ): Generator {
      const res: any = yield call(conversationSessionId);
      const { enablePlugins, gptMode, chatTextarea } = (yield select(
        (state: RootState) => {
          return state.chatParameter;
        },
      )) as ChatParameter;

      const { chatGptConfig } = (yield select(
        (state: RootState) => state.chatMessage,
      )) as ChatMessage;

      const { siteConfig } = (yield select(
        (state: RootState) => state.site,
      )) as NSite.IModelState;

      // 判空是否未输入
      if (!payload && !chatTextarea) {
        message.destroy();
        message.warning("请输入要提问的内容~");
        return;
      }

      let limitNum = siteConfig.ai_chat_input_length;
      if (gptMode.model === "gpt-5" && siteConfig.gpt_plus_enable === "true") {
        limitNum = siteConfig.gpt4_token_length_limit;
      } else if (gptMode.model === "claude") {
        limitNum = siteConfig.claude_ai_chat_input_length;
      } else if (gptMode.model === "o1-mini") {
        limitNum = siteConfig.ai_chat_o1_input_length;
      } else if (gptMode.model === "o1-preview") {
        limitNum = siteConfig.ai_chat_o1_pre_input_length;
      } else if (gptMode.model === "deepseek-ai/DeepSeek-R1") {
        limitNum = siteConfig.deepseek_reasoner_ai_chat_input_length;
      }

      console.log(limitNum, "limitNum");

      // if (getChatTextLengthTip(chatTextarea || "",
      // gptMode.model === "gpt-4" && siteConfig.gpt_plus_enable === "true" ? siteConfig.gpt4_token_length_limit : siteConfig.ai_chat_input_length)) {
      //   return;
      // }
      if (yield getChatTextLengthTip(chatTextarea || "", limitNum)) {
        return;
      }

      if (res.code === 0) {
        const pluginType = enablePlugins.join(",");
        const isGpt4 = gptMode.model === "gpt-5";
        yield put({
          type: "chatParameter/setConversationItem",
          payload: {
            id: res.data.sessionId,
            pluginType: isGpt4 ? pluginType : undefined,
          },
        });

        yield put({
          type: "setData",
          payload: {
            chatPending: false,
            chatMessageList: [],
            historyLoading: false,
          },
        });

        const requestConfig: ChatGptConfig = {
          ...chatGptConfig,
          fileDataId: undefined,
          gptFileIds: [],
          isContinue: false,
          promptId: chatGptConfig.promptId || 0,
          sessionId: res.data.sessionId,
          rolePlayId: undefined,
          pluginType: isGpt4 || pluginType,
        };

        yield put({
          type: "setData",
          payload: { chatGptConfig: requestConfig, chatMessageList: [] },
        });

        yield put({ type: "chat", payload: payload });
      }
      return res;
    },
  },
};
